import React from 'react';
import loadable from '@loadable/component';
import Loading from '../Loading';

const UploadImageModal = loadable(() => import('./UploadImageModal'), {
    fallback: <Loading />,
});

// loadable() erases prop types in this codebase; keep it permissive.
export default UploadImageModal as React.ComponentType<any>;
